import { StrapiArticleContactDetailsProps } from "@components/strapi/ArticleContactDetails/types"
import pushToDataLayer from "@logic/data-layers/pushToDataLayer"
import React, { FC } from "react"
import { ContactDetailsWrapper, LeftColumn, RightColumn, Row } from "./styles"

const ContactDetails: FC<StrapiArticleContactDetailsProps> = ({
  items,
}) => {
  return <ContactDetailsWrapper>
    {items.map((item, index) => (
      <Row key={index}>
        <LeftColumn>{item.title}</LeftColumn>
        <RightColumn>{item.title === 'Telefoonnummer:' ? (
          <a 
            href={`tel:${item.value.replace(/\D/g, '')}`}
            onClick={() => {
              pushToDataLayer({
                event: 'interaction',
                event_name: 'call',
                phone: item.value.replace(/\D/g, ''),
                product: 'website'
              })
            }}
          >
            {item.value}
          </a>
        ) : item.value}</RightColumn>
      </Row>
    ))}
  </ContactDetailsWrapper>
}

export default ContactDetails